document.addEventListener('DOMContentLoaded', function () {
  const stickyBanner = document.getElementById('sticky-banner')
  const pageElements = [
    document.querySelector('[id*="sleepdoctor_sharma_lp_hero"]'),
    document.querySelector('[id*="sleepdoctor_sharma_lp_featured_product"]'),
    document.getElementById('shopify-section-sleepdoctor-sharma-lp-footer')
  ]

  if (stickyBanner !== null) {
    const intersectionCallback = (entries, observer) => {
      let bannerVisible = true

      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          bannerVisible = false
        }
      })

      stickyBanner.style.display = bannerVisible ? 'block' : 'none'
    }

    const intersectionOptions = {
      root: null,
      threshold: 0.1
    }

    /* eslint-disable no-undef */
    const intersectionObserver = new IntersectionObserver(intersectionCallback, intersectionOptions)
    /* eslint-enable no-undef */

    if (pageElements[0] !== null) {
      pageElements.forEach((element) => {
        if (element !== null) {
          intersectionObserver.observe(element)
        }
      })
    }
  }
})
